module.exports = __webpack_public_path__ + "img/hopways-03.56457051.jpeg";